import React from 'react';
import Navbar from '../components/Navbar';


function AddressChange() {



    

    return (
        <div className='min-h-screen flex flex-col  flex-1 pb-5 bg-[#F7F7F7]'>
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            
                <div className='w-full lg:px-[7%] px-[2%] flex flex-col  mt-5'>
                    <span className='font-[700] width-full flex text-2xl font-display '>Select Delivery Address</span>



                    <div className='w-full flex lg:flex-row flex-col gap-8 mt-8'>
                        <div className='lg:w-[70%] w-full  h-auto flex flex-col gap-3'>
                            <div className='rounded-[5px] lg:h-[58px] h-auto bg-[#FFF6F4] justify-between flex lg:flex-row flex-row lg:items-center items-start lg:py-0 py-3 lg:px-5 px-1 lg:gap-0 gap-3'>
                                <span className='lg:text-sm text-xs font-[400] font-display'>Deliver to :&nbsp;&nbsp;&nbsp;Gopu Ramesh Shersoft Software Company
                                </span>
                                <span className='lg:w-[10%] w-[30%] h-[30px] border-2 border-[#8B0000] rounded-[3.51px] flex justify-center items-center text-[#8B0000] lg:text-sm text-xs font-[400] font-display cursor-pointer' >
                                    Change
                                </span>
                            </div>

                        

                            <div className='rounded-[5px] h-[60px] bg-[#FFF6F4] justify-between flex items-center lg:px-5 px-1'>
                                <span className='text-sm font-[400] font-display'>Add More From Wishlist
                                </span>

                            </div>


                        
                        </div>


                        <div className='lg:w-[30%] w-full h-[321px] flex flex-col rounded-[2px] border-2 border-[#EAEAEC] lg:mb-0 mb-[25%]'>
                            <div className='w-full h-[18%] bg-[#FFF6F4] px-3 flex justify-between items-center text-base font-[600] font-[display]'>
                                Price Details
                            </div>

                            <div className='w-full h-[82%]   flex  flex-col px-3 gap-5'>

                                <ul className='border-2 border-black mt-5 text-[#F0F0F0]' />
                                <div className='flex flex-col gap-5 w-full'>
                                    <div className='w-full flex justify-between'>
                                        <span className='text-base font-[400] font-display'>Price (2)</span>
                                        <span className='text-base font-[600] font-display'>₹500</span>
                                    </div>
                                    <div className='w-full flex justify-between'>
                                        <span className='text-base font-[400] font-display'>Discount</span>
                                        <span className='text-base font-[600] font-display'></span>

                                    </div>
                                    <div className='w-full flex justify-between'>
                                        <span className='text-base font-[400] font-display'>Delivery Charges</span>
                                        <span className='text-base font-[600] font-display'>₹00.00</span>
                                    </div>
                                </div>
                                <ul className="border-b-2 border-black border-dashed " />
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[600] font-display'>Total Amount</span>
                                    <span className='text-base font-[600] font-display'>₹500</span>
                                </div>
                                <ul className="border-b-2 border-black border-dashed " />

                            </div>


                        </div>
                        <div className=' h-[80px] bg-[#FFF6F4] justify-center lg:hidden flex items-center  fixed bottom-0 w-full'>

                            <div className='h-[50px] w-[50%] bg-[#BB002D] rounded-[5px] flex justify-center items-center text-base font-[500] font-display text-[white] cursor-pointer' >
                                Place Order
                            </div>
                        </div>
                    </div>
                </div>
          
        </div>
    )
}

export default AddressChange;
